export default {
  namespaced: true,
  state: () => ({
    currentItem: {
      imagens: [],
    },
    gradeAtual: [],
    fields_default: [],
    fields_custom: [],
    item: {
      id: null,
      nome_fantasia: null,
      razao_social: null,
      cnpj: null,
      subdominio: null,
      status: 1,
    },
    items_all: [],
    filters: {
      page: 1,
      perPage: 10,
      sortBy: 'id',
      sortDesc: null,
      total: 0,
    },
    isLoading: false,
    excludeFields: ['created_at', 'updated_at', 'deleted_at'],
  }),
  mutations: {
    SET_ITEMS_ALL(state, payload) {
      state.items_all = payload;
    },
    SET_ITEM(state, payload) {
      state.item = payload;
    },
    SET_FILTERS(state, payload) {
      state.filters = payload;
    },
    SET_FIELDS_DEFAULT(state, payload) {
      state.fields_default = payload;
    },
    SET_FIELDS_CUSTOM(state, payload) {
      state.fields_default.concat(payload);
      state.fields_custom = payload;
    },
    SET_CURRENT_ITEM(state, payload) {
      state.currentItem = payload;
    },
    SET_GRADE_ATUAL(state, payload) {
      state.gradeAtual = payload;
    },

  },
  getters: {
    GET_FILTERS(state) {
      return state.filters;
    },
    GET_ITEMS_ALL(state) {
      return state.items_all;
    },
    GET_ITEM(state) {
      return state.item;
    },
    GET_FIELDS_DEFAULT(state) {
      return state.fields_default.filter((field) => !state.excludeFields.includes(field.key));
    },
    GET_FIELDS_CUSTOM(state) {
      return state.fields_custom;
    },
    GET_CURRENT_ITEM(state) {
      return state.currentItem;
    },
    GET_GRADE_ATUAL(state) {
      return state.gradeAtual;
    },

  },
};
